<template>
  <div id="subscription-tab" class="mt-2">
    <card-widget>
      <template #cardBody>
        <v-row no-gutters>
          <v-col cols="12" md="12">
            <h6 class="text-h6 font-weight-large secondary--font">
              {{ $dictionary.app.customers.index.trailingHistoryTitle }}
            </h6>
            <div>&nbsp;</div>
          </v-col>
        </v-row>

        <v-row no-gutters class="body-2 pt-8 text--secondary">
          <v-col cols="12" md="2" v-for="item in usage" :key="item.monthName">
            <div class="py-3 pl-8 border-bottom-grey">{{ item.monthName }}</div>
            <div class="py-3 pl-8">
              <template v-if="item.count">
                <v-chip
                  label
                  v-if="item.count > totalAllottedReport"
                  class="px-1"
                  :text-color="$appConfig.usage.textColor"
                  :color="$appConfig.usage.backgroundColor"
                >
                  {{ item.count }}/{{ totalAllottedReport }}
                </v-chip>
                <div class="mt-2 mb-1" v-else>
                  {{ item.count }}/{{ totalAllottedReport }}
                </div>
                <div>({{ item.percentage }}%)</div>
              </template>
              <template v-else>
                N/A
              </template>
            </div>
          </v-col>

          <loader :loading="isLoading" :size="$appConfig.loader.small" />
        </v-row>
      </template>
    </card-widget>
    <add-customer-form
      :customer="customer"
      :subscription="{ ...customer.subscription_package }"
      :show-customer-info="showCustomerInfo"
      :success-message="successMessage"
    ></add-customer-form>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { CardWidget } from "@/components/widgets";
import { AddCustomerForm } from "@/components/forms";
import { getCustomerUsage } from "@/services";

import dayjs from "dayjs";

/**
 * Customer Subscription view
 */
export default {
  name: "CustomerSubscription",
  /**
   * --------------Components -------------------
   */
  components: {
    AddCustomerForm,
    CardWidget,
  },
  /**
   * ---------------Data Attributes ---------------
   */
  data() {
    return {
      usage: [],
      isLoading: false,
      showCustomerInfo: false,
      successMessage: this.$dictionary.app.customers?.update
        ?.subscriptionSuccessMsg,
    };
  },
  /**
   * ------------- Props ----------------
   */
  props: {
    customer: { type: Object, required: true },
  },
  /**
   * ----------------- Computed Properties -----------
   */
  computed: {
    /**
     * get total Alloted
     */
    totalAllottedReport() {
      return this.customer?.subscription_package?.placement_reports_number;
    },

    /**
     * get customer id
     */
    customerId() {
      return this.$route.params?.id;
    },
    /**
     * get last six month
     */
    getlastSixMonth() {
      const today = dayjs()
        .utc()
        .toDate();
      const months = [];
      for (let i = 0; i < 6; i += 1) {
        let date = new Date(today.getFullYear(), today.getMonth() - i, 2);
        months.push(`${date.getMonthName()} ${date.getFullYear()}`);
      }
      return months;
    },
  },
  /**
   * -----------Methods ------------------
   */
  methods: {
    ...mapActions({
      setSnackbar: "ui/setSnackbar",
    }),
    /**
     * Fetched the customer usage list
     */
    async getUsage() {
      try {
        this.isLoading = true;
        let { data } = await getCustomerUsage(this.customerId);
        if (data) {
          this.usage = this.getlastSixMonth.map((monthName) => {
            const usageObj = data.find(
              (d) => monthName == this.getMonthYearName(d.month)
            );

            return usageObj
              ? {
                  ...usageObj,
                  monthName,
                  percentage: this.usagePercentage(usageObj.count),
                }
              : { monthName };
          });
        }
      } catch (error) {
        this.setSnackbar({
          value: true,
          type: this.$appConfig.snackbar.snackbarTypes.error,
          message: this.$errorMessage(error),
        });
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * Calculate usage percentage
     * @returns {Number}
     */
    usagePercentage(count) {
      if (this.totalAllottedReport && this.totalAllottedReport > 0) {
        return ((count / this.totalAllottedReport) * 100).toFixed(2);
      } else {
        return "00.00";
      }
    },
    /**
     * get month and year name
     * @return {String}
     */
    getMonthYearName(value) {
      const date = dayjs(value?.substring(0, 23))
        .utc()
        .toDate();

      return `${date.getMonthName()} ${date.getFullYear()}`;
    },
  },
  /**
   * ---------------- Mounted --------------------
   */
  mounted() {
    this.getUsage();
  },
};
</script>
